export default defineNuxtRouteMiddleware((to) => {
  const isMergedLotteryPage = useIsMergedLotteryPage(to.params.lotteryId)
  if (!isMergedLotteryPage) return

  const localePath = useLocalePath()
  const lotteryId = String(to.params.lotteryId).toLowerCase()

  return navigateTo(localePath({ path: `/${lotteryId}`, query: to.query, hash: to.hash }), {
    replace: true,
  })
})
